// Import package from node modules
import * as types from "../types";

export const setPages = pages => {
  return {
    type: types.SET_PAGES,
    pages: pages
  };
};

export const setDevelopments = developments => {
  return {
    type: types.SET_DEVELOPMENTS,
    developments: developments
  };
};

export const setDevelopmentProperties = developmentProperties => {
  return {
    type: types.SET_DEVELOPMENTS_PROPERTIES,
    developmentProperties: developmentProperties
  };
};

export const setSplashData = splashData => {
  return {
    type: types.SET_SPLASHDATA,
    splashData: splashData
  };
};

export const setIDCheck = idcheck => {
  return {
    type: types.SET_ID_CHECK,
    idcheck: idcheck
  };
};
